'use client';
import { MindfulAudioImg } from '@/config/img/mindfulAudio';
import { useClientTranslation } from '@/hook/translate';
import { mindful } from '@/types/audioResData';
import { Image } from '@nextui-org/react';
import useAudio from '@/hook/useAudio';
import MobilePlayer from './MobilePlayer';
import MobileAudioBar from './MobileAudiobar';
import MobileContent from './MobileContent';

interface IProps {
  title: string;
  author: string;
  subTitle: string;
  update: string;
  score: string;
  rate: string;
  isFull: boolean;
  youtubeId?: string;
  about: mindful.TAbout;
  chapters: mindful.TChapter[];
  audioPath: string;
}

export default function MobileAudioContent(props: IProps) {
  const { t } = useClientTranslation();
  const audioURL = props.audioPath || '';
  const { about } = props;
  const {
    play,
    pause,
    duration,
    audioStatus,
    currentTime,
    changeCurrentTime,
  } = useAudio(audioURL);
  return (
    <div>
      <div className="card bg-[#E7FBB0] px-[15px] rounded-[20px] mt-5 pb-[5px]">
        <h1 className='title pt-[30px] text-center text-26-36 font-black'>
          {props.title} {props.isFull ? t('fullAudio', 'mindfulAudio') : t('summaryAudio', 'mindfulAudio')}
        </h1>
        <p className='author text-center pt-[10px] text-18-27 font-semibold'>{props.author}</p>
        <p className='desc   text-center text-14-19 pt-[5px] px-4'>{props.subTitle}</p>
        <div className='flex items-center justify-center pt-3' key={'star'}>
          <div className='star-wrap flex justify-center'>
            <Image src={MindfulAudioImg.Star} alt='stars' width={18} height={18} />
          </div>
          <span className='  text-[14px] pl-1'>{props.score}</span>
          <span className='text-[rgba(0, 0, 0,0.5)] text-[10px] pl-[5px] leading-[21px]'>
            <span>{props.rate}</span>
            <span className='pr-1'>{t('rating', 'mindfulAudio')}</span>
            <span className='pr-1'>({t('readerRefer', 'mindfulAudio')})</span>
          </span>
        </div>
        {/* <MobileAudioBar url={ props.url } /> */}
        {
          props.youtubeId ?
            <MobilePlayer videoId={props.youtubeId} />
            :
            <MobileAudioBar
              play={play}
              pause={pause}
              duration={duration}
              audioStatus={audioStatus}
              currentTime={currentTime}
              changeCurrentTime={changeCurrentTime}
              url={audioURL}
            />
        }

      </div>
      <div className='mt-10'>
        <h2 className='text-left text-20-27 font-extrabold'>
          <span>{t('information', 'mindfulAudio')}</span>
        </h2>
        <div className="cover py-5 mt-[10px] flex justify-center bg-[#F7F8FA]">
          <Image width={120} height={80} radius='none' className='rounded-r-[8px]' src={about.url} alt='cover' />
        </div>
        <div className="about pt-[10px]">

          <div className="info text-16-22 font-semibold flex flex-col items-center">
            <p>{t('author', 'mindfulAudio')}: {about.author}</p>
            <p className='pt-[10px]'>{t('narrator', 'mindfulAudio')}: {about.narrator}</p>
            <p className='pt-[10px]'>{t('format', 'mindfulAudio')}: {about.format}</p>
            <p className='pt-[10px]'>{t('ibsn', 'mindfulAudio')}: {about.ISBN}</p>
            <p className='pt-[10px]'>{t('language', 'mindfulAudio')}: {about.language}</p>
            <p className='pt-[10px]'>{t('publishDate', 'mindfulAudio')}: {about.publishDate}</p>
            <p className='pt-[10px]'>{t('audioLength', 'mindfulAudio')}: {about.times} {t('minute', 'mindfulAudio')}</p>
          </div>
        </div>
      </div>
      <MobileContent  showTitle={ !!props.youtubeId } chapters={ props.chapters } title={ props.title }  play={play} pause={ pause } audioStatus={ audioStatus }  />
    </div>
  );
}
